module.exports = __webpack_public_path__ + "static/media/domesticControlRoom.c333b9d8.jpg";